import * as actions from '../actions/selectSuggestionActions';

export const initialState = {
   currentIndex: null,
   exclusiveDestinationSelected: null
};

export default function postsReducer(state = initialState, action) {
   switch (action.type) {
      case actions.CLEAN_SELECTION:
         saveStateInLocalStorage({
            currentIndex: null,
            exclusiveDestinationSelected: null
         });
         return {
            ...state,
            currentIndex: null,
            exclusiveDestinationSelected: null
         }
      case actions.SET_SELECTION:
         saveStateInLocalStorage({
            currentIndex: action.payload.currentIndex,
            exclusiveDestinationSelected: action.payload.exclusiveDestinationSelected
         });
         return { 
            ...state, 
            currentIndex: action.payload.currentIndex,
            exclusiveDestinationSelected: action.payload.exclusiveDestinationSelected
         };
      default:
         return state;
   }
}

function saveStateInLocalStorage(data) {
   localStorage.setItem('selectionHsDs', JSON.stringify(data));
}


// WEBPACK FOOTER //
// ./src/reducers/selectSuggestionReducer.js